module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_12792761_S-small-b2bd3175c1d179c3759390eb092cc7d4.jpg";